"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessPageHighchartsOptionsProvider = void 0;
const React = __importStar(require("react"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const StickinessJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessJSONModel");
const StickinessPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageModelProvider");
const StickinessPageHighchartsOptionsProvider = (props) => {
    const pageDataContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const pageModelContext = (0, StickinessPageModelProvider_1.useStickinessPageModelContext)();
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const lineType = urlJSONModel.getLineTypeJSONModel().getLineType();
    const chartSettingsJSONModel = urlJSONModel.getChartSettingsJSONModel();
    const chartType = chartSettingsJSONModel.getChartType();
    const filterCohortDays = chartSettingsJSONModel.getFilterCohortDays();
    const filterFrequency = chartSettingsJSONModel.getFilterFrequency();
    const formModelSerialized = pageModelContext.pageModelStateFns.getFormJSONModel().serialize();
    const urlModelSerialized = urlJSONModel.serialize();
    const highchartsChartStatus = calculateHighchartsChartStatus(formModelSerialized, urlModelSerialized);
    return React.createElement(React.Fragment, null,
        React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: pageDataContext.state.error, data: pageDataContext.state.data, parameters: {
                chartType: chartType,
                lineType: lineType,
                filterCohortDays: { ...filterCohortDays },
                filterFrequency: { ...filterFrequency },
                shouldAddPeriod: false
            }, highchartsOptionsProviderFn: ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getStickiness, chartStatus: highchartsChartStatus }, props.children));
};
exports.StickinessPageHighchartsOptionsProvider = StickinessPageHighchartsOptionsProvider;
const calculateHighchartsChartStatus = (formModel, urlModel) => {
    formModel = StickinessJSONModel_1.StickinessJSONModel.makeModelStateClean(formModel);
    urlModel = StickinessJSONModel_1.StickinessJSONModel.makeModelStateClean(urlModel);
    const formModelEmpty = StickinessJSONModel_1.StickinessJSONModel.isModelEmpty(formModel);
    const urlModelEmpty = StickinessJSONModel_1.StickinessJSONModel.isModelEmpty(urlModel);
    if (urlModelEmpty) {
        return { status: "notLoaded" };
    }
    else {
        const formModelEqualsToURLModel = lodash_1.default.isEqual(formModel, urlModel);
        if (formModelEqualsToURLModel) {
            return { status: "loaded" };
        }
        if (formModelEmpty) {
            return { status: "parametersChangedButEmpty" };
        }
        else {
            return { status: "parametersChanged" };
        }
    }
};
